import * as $ from 'jquery';
import {Global} from '../init-global';

require('jquery-debounced-and-throttled-resize/jquery.debouncedresize.js');
import { TweenLite, TimelineLite, Sine, Power3 } from 'gsap';
const activated = [ TweenLite, TimelineLite, Sine, Power3 ];


export class NavigationComponent {

    protected $window: JQuery;
    protected $header: JQuery;
    protected $navToggle: JQuery;
    protected $logoText: JQuery;
    protected $mainNav:JQuery;
    protected $mobileSocialNav:JQuery;
    protected $navContainer:JQuery;
    protected mobNavOverlay:JQuery;
    protected $root: JQuery;
    protected isMobile: boolean;
    protected breakpoint:number = 980;
    protected stickyAt:number = 80;
    protected headerHeight:number;
    protected timeoutIDIn: any;
    protected timeoutIDOut: any;
    protected isLocked = false;
    protected didScroll:boolean;
    protected lastScrollTop:number = 0;
    protected delta:number = 5;
    protected navbarHeight:number = $('.l-header').outerHeight();
    protected tl:TimelineLite;
    protected $subMenuTriggers:JQuery;
    protected $subMenus:JQuery;
    protected $subLinks:JQuery;


    constructor(elem: HTMLElement)
    {
        this.$window  = $(<any>window);
        this.$root    = $(elem);
        this.bindUI();
    }

    private bindUI = () => {
        this.$header          = $('.js-nav-header');
        this.$navToggle       = $('.js-primary-nav-toggle', this.$header);
        this.$mainNav         = $('.c-primary-nav__list', this.$root);
        this.$navContainer    = $('.c-primary-nav__wrap', this.$root);
        this.$mobileSocialNav = $('.c-mobile-nav-social-channels', this.$root);
        this.$subMenus        = $('.js-submenu', this.$root);
        this.$subLinks        = $('a', this.$subMenus);
        this.$subMenuTriggers = $('[aria-haspopup=true]', this.$root);

        this.$subLinks.attr('tabindex', '-1');

        this.$navToggle.on({
            click: (e:any) => {
                if (!this.isLocked)
                    !this.$navToggle.hasClass('is-open') ? this.openMenu() : this.closeMenu();
                e.preventDefault();
            }
        });


        /* Set up the sub menu 
        */

        this.setInitialState();

        this.$window.on('scroll.stickynav', () => { this.didScroll = true; });

        setInterval(() => {
            if (this.didScroll) {
                this.hasScrolled();
                this.didScroll = false;
            }
        }, 250);

        // Watch the viewport for size changes
        $(window).on('debouncedresize', () => this.refreshViewport());
    }

    /* *** OPEN MENU *** */
    private openMenu = () => {
        this.$navToggle.attr('aria-expanded', String(!this.getExpanded()));
        this.isLocked = true;

        this.mobNavOverlay = $(Global.newTag('div', 'u-mobilenav-overlay'));
        this.mobNavOverlay.css('opacity', 0);

        if (typeof this.tl != 'undefined') this.tl.clear();

        this.tl = new TimelineLite( { delay: 0.25, onComplete: () => {
            this.isLocked = false;
            this.$navToggle.addClass('is-open');
        }});

        this.tl.add(() => { 
            this.$navContainer.get(0).hidden = false;
            $('body').addClass('has-nav-overlay').append(this.mobNavOverlay);
        })
        .fromTo(this.$navContainer, 0.3, { left: '-100%' }, { left: '0%', ease: Sine.easeOut })
        .to(this.mobNavOverlay, 0.5, { opacity: 1, ease: Sine.easeOut }, '-=0.3')
        .add(() => { this.$navToggle.add(this.$navContainer).addClass('is-open'); }, '-=0.6' );
    }

    /* *** CLOSE MENU *** */
    private closeMenu = () => {
        this.$navToggle.attr('aria-expanded', String(!this.getExpanded()));
        this.isLocked = true;
        if (typeof this.tl != 'undefined') this.tl.clear();

        this.tl = new TimelineLite( { delay: 0.15, onComplete: () => {
            this.isLocked = false;
            this.$navContainer.get(0).hidden = true;
            $('body').removeClass('has-nav-overlay');
            if (typeof this.mobNavOverlay != 'undefined') this.mobNavOverlay.remove();
            TweenLite.set(this.$navContainer, { clearProps: 'all' });
        }});

        this.tl.to(this.$navContainer, 0.3, { left: '-100%', ease: Sine.easeOut })
        .to(this.mobNavOverlay, 0.3, { opacity: 0, ease: Sine.easeOut }, '-=0.3')
        .add(() => { this.$navToggle.add(this.$navContainer).removeClass('is-open'); }, '-=0.6' );
    }

    private hasScrolled = () => {
        let st = this.$window.scrollTop();
        
        // Make sure they scroll more than delta
        if (Math.abs(this.lastScrollTop - st) <= this.delta)
            return;
        
        if (st > this.lastScrollTop && st > this.navbarHeight){
            // Scroll Down
            $('.l-header').attr('is-sticky', 'false').addClass('nav-hidden');
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height() && st > this.navbarHeight) {
                $('.l-header').removeClass('nav-hidden').attr('is-sticky', 'true');
            }

            if (st === 0) {
                $('.l-header').removeClass('nav-hidden').attr('is-sticky', 'false');
            }
        }
        
        this.lastScrollTop = st;
    }

    private calcSplitMenuPosition = () => {
        let navWidth = this.$mainNav.width();
        let halfpoint = 0;

        TweenLite.set(this.$mainNav, { clearProps: 'all' });

        // Find where the split will occur
        let midIndex = Math.round(this.$mainNav.children().length / 2) - 1;

        // Find the offset
        for (let i=0; i<=midIndex; i++) {
            halfpoint += this.$mainNav.children().eq(i).outerWidth(true);
        }
        let strOffset = 'translate(' + Math.round(navWidth/2-halfpoint).toString() + 'px' + ', 0)';
        
        // Finally apply offset
        this.$mainNav.css({
            '-webkit-transform' : strOffset,
            '-ms-transform'     : strOffset,
            'transform'         : strOffset
        });
    };

    /* INIT MOBILE
    */

    private initMobile = () => {
        TweenLite.set(this.$mainNav, { clearProps: 'all' });
        this.$mobileSocialNav.get(0).hidden = false;
        this.$navContainer.get(0).hidden    = true;

        this.$subMenuTriggers.off('click');
        this.$subMenuTriggers.parent().off('mouseenter mouseleave');
    }

    /* INIT DESKTOP
    */

    private initDesktop = () => {
        $('body').removeClass('has-nav-overlay');
        TweenLite.set(this.$navContainer, { clearProps: 'all' });
        if (typeof this.mobNavOverlay != 'undefined')
            this.mobNavOverlay.remove();
        this.calcSplitMenuPosition();
        this.$mobileSocialNav.get(0).hidden = true;
        this.$navContainer.get(0).hidden    = false;
        this.killActiveSubMenus();

        this.$subMenuTriggers.on({
            touchstart: (e:any) => { 
                if (!$(e.currentTarget).hasClass('show-sub')) {
                    this.killActiveSubMenus();
                    this.setSubMenuVisibility($(e.currentTarget));
                    $(e.currentTarget).addClass('show-sub')
                    e.preventDefault();
                }
            }
        });

        this.$subMenuTriggers.parent().on({
            mouseenter: (e:any) => { 
                this.killActiveSubMenus();
                this.setSubMenuVisibility($('[aria-haspopup=true]', e.currentTarget));
            },
            mouseleave: (e:any) => { 
                this.setSubMenuVisibility($('[aria-haspopup=true]', e.currentTarget));
            }
        });

        this.$subMenuTriggers.on({
            focus: (e:any) => { 
                this.killActiveSubMenus();
                this.setSubMenuVisibility($(e.currentTarget));
            }
        });
    }

    private getExpanded = () => {
        return this.$navToggle.attr('aria-expanded') === 'true' || false;
    }

    private refreshViewport = () => {
        let vp = Global.getViewport();
        let dspForMobile:boolean = (vp.width < this.breakpoint) ? true: false;

        if (dspForMobile != this.isMobile) {
            this.isMobile = dspForMobile;
            (this.isMobile) ? this.initMobile(): this.initDesktop();
        }

        if (vp.width >= this.breakpoint) { this.calcSplitMenuPosition(); }
    }

    private setInitialState = () => {
        this.refreshViewport();
        this.hasScrolled();
        this.$header.addClass('is-initialised');
        setTimeout(() => { this.$header.addClass('animate'); }, 300);
    }


    private killActiveSubMenus = () => {
        this.$subMenuTriggers.removeClass('show-sub');
        this.$subMenus.each((i, elem) => {
            $(elem).prev().removeClass('on-hover show-sub').attr('aria-expanded', 'false');
            $(elem).get(0).hidden = true;
        });
    }

    private setSubMenuVisibility = ($target:JQuery) => {
        let $submenu = $('.js-submenu', $target.parent());
        let expanded = $target.attr('aria-expanded') === 'true' || false;
        $target.attr('aria-expanded', String(!expanded));
        $submenu.get(0).hidden = !$submenu.get(0).hidden;

        $target.toggleClass('on-hover');

        if (!expanded) {
            if (typeof this.timeoutIDIn != 'undefined') { clearTimeout(this.timeoutIDIn); }
            this.timeoutIDIn = setTimeout(() => { $target.addClass('show-sub'); }, 300);
        } else {
            $target.removeClass('show-sub');
        }
    }
}